import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../ProjectHeroImage";
import Links from "../../../Links";
import Image from "../../../../img/opennote.png";

const OpenNoteProjectSection = styled(ProjectSection)`
  background: oklch(0.21 0 0);
`;

const Button = styled(Links)`
  display: block;
  background-color: rgba(0, 0, 0, 0.05);
  display: inline-block;
  text-align: center;
  color: white;
  height: auto;
  text-decoration: none;
  padding: 0px 1.5em;
  border-radius: 3.125em;
  line-height: 3;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border-bottom: none;
  font-size: var(--font-size-text-small);
  &:hover,
  &:active {
    background-color: rgba(0, 0, 0, 0.3);
    color: white;
  }
  &:visited {
    color: white;
  }
  &:focus {
    outline-color: white;
  }
`;

const ButtonGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  gap: var(--spacing-small);
  margin-bottom: var(--spacing-large);

  @media (min-width: 500px) {
    grid-template-columns: auto auto auto;
  }
`;

function OpenNote() {
  return (
    <OpenNoteProjectSection>
      <ProjectTitle title="OpenNote" tag="2026" />
      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
        <Badge small title="React">
          <Icons type="react-small" />
        </Badge>
      </ProjectSectionSkills>

      <ProjectDescription>
        One note, and AI chooses the rest. OpenNote is a music concept built around a simple prompt: give the system a
        single anchor note, then let AI explore the surrounding space and infer what should come next. It is available
        as both a CLI and a web app.
      </ProjectDescription>

      <ProjectDescription>
        The idea came from thinking about Geoffrey Hinton’s explanation of how early systems could recognise objects by
        detecting patterns in pixels. Applied to music, that same framing becomes compelling: start with one note,
        treat it as the anchor point, and let the model discover structure, relationships, and progression from there.
      </ProjectDescription>

      <ButtonGroup>
        <Button
          href="https://opennote.redactd.xyz/"
          color="white"
          target="_blank"
          rel="noopener noreferrer"
        >
          CLI Web
        </Button>
        <Button
          href="https://youtu.be/CA54KtJ-JNo?si=quVcjtsivvLr52sh"
          color="white"
          target="_blank"
          rel="noopener noreferrer"
        >
          Watch video
        </Button>
        <Button
          href="https://github.com/michaeltrilford/OpenNote"
          color="white"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get CLI
        </Button>
      </ButtonGroup>

      <ProjectHeroImage src={Image} desktop />
    </OpenNoteProjectSection>
  );
}

export default OpenNote;
